import { render } from "./5VideoAsset.vue?vue&type=template&id=3930179a&scoped=true"
import script from "./5VideoAsset.vue?vue&type=script&lang=js"
export * from "./5VideoAsset.vue?vue&type=script&lang=js"

import "./5VideoAsset.vue?vue&type=style&index=0&id=3930179a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3930179a"]])

export default __exports__